import { clsx } from "clsx";
import { CheckboxOption } from "./utils/helpers";
import "./styles/NicheOption.scss";

interface INicheOption {
  niche: CheckboxOption;
  indx: number;
  onChange: (indx: number, available: boolean) => void;
}

export const NicheOption = (props: INicheOption) => {
  const {
    niche: {
      name,
      value,
      isChecked,
      label,
      disabled,
      available
    },
    onChange,
    indx
  } = props;

  return (
    <div
      data-testid="niche-option"
      className={
        clsx(
          "NicheOption",
          isChecked && "NicheOption_isChecked",
          disabled && "NicheOption_isDisabled",
          !available && "NicheOption_isNotAvailable"
        )
      }
    >
      <label className="NicheOption-Label" htmlFor={name}>
        {label}
        <input
          className="NicheOption-Input"
          type="checkbox"
          value={value}
          name={name}
          id={name}
          aria-label={name}
          checked={isChecked}
          onChange={() => onChange(indx, !!available)}
          disabled={disabled}
        />
        <div className="NicheOption-Control"></div>
      </label>
    </div>
  );
};
